import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * Backup Export + Restore controls (the top half of the Backup & Restore card).
 * Presentational — parent owns backupMessage and the handler implementations.
 */
export const BackupExportRestore = ({ onBackup, onRestore, backupMessage }) => (
  <>
    <div className="p-4 bg-muted/50 rounded-lg">
      <h4 className="font-medium mb-2">📥 Export Backup</h4>
      <p className="text-sm text-muted-foreground mb-3">
        Download a complete backup of all games, tickets, and settings.
      </p>
      <Button onClick={onBackup} className="w-full" data-testid="download-backup-btn">
        Download Backup
      </Button>
    </div>

    <div className="p-4 bg-muted/50 rounded-lg">
      <h4 className="font-medium mb-2">📤 Restore from Backup</h4>
      <p className="text-sm text-muted-foreground mb-3">
        ⚠️ Warning: This will replace all current data.
      </p>
      <Input
        type="file"
        accept=".json"
        onChange={onRestore}
        className="cursor-pointer"
        data-testid="restore-backup-input"
      />
    </div>

    {backupMessage && (
      <p
        data-testid="backup-message"
        className={`text-sm text-center ${backupMessage.includes('✅') ? 'text-green-600' : backupMessage.includes('❌') ? 'text-red-500' : 'text-blue-500'}`}
      >
        {backupMessage}
      </p>
    )}
  </>
);

export default BackupExportRestore;
